export default __webpack_public_path__ + "static/media/panini.d35df392.png";